var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDomicile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 40,
    viewBox: "0 0 69 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 67,
    height: 38,
    rx: 3,
    fill: "white",
    stroke: "#DEDFE0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.216 14.376H26.04V12.336H13.896V14.376H18.72V16.44C18.72 20.16 16.488 24.192 13.128 25.752L14.544 27.72C17.088 26.496 19.032 23.928 19.992 20.904C21 23.712 22.944 26.064 25.464 27.168L26.832 25.224C23.448 23.784 21.216 20.04 21.216 16.44V14.376ZM28.56 10.176V31.848H31.056V10.176H28.56ZM43.8461 20.664H38.7341V17.136H43.8461V20.664ZM46.2701 18.144H50.7821V26.232H53.2541V10.176H50.7821V16.128H46.2701V11.616H43.8461V15.192H38.7341V11.616H36.2861V22.68H46.2701V18.144ZM41.6381 29.424V24.648H39.1421V31.44H53.7581V29.424H41.6381Z",
    fill: "#9D9D9E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomicile);
export default __webpack_public_path__ + "static/media/domicile.198ee47f.svg";
export { ForwardRef as ReactComponent };